import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utility';
import {setToken} from '../../utilities/utilitiesToken';

const initialState = {
  userData: {},
  userDataFetched: false,
  notifications: {},
  userSettings: {
    fontSize: localStorage.getItem('font-size') || 'normal',
    codePreview: localStorage.getItem('codePreview') || 'on',
  },
  sessionDataRestored: false,
  subscriptionSettings: {},
};

const setUserData = (state, action) => {
  setToken(action.data.token);
  setToken(action.data.gridicsApiPublicToken, true);
  return updateObject(state, {
    userData: action.data,
    userDataFetched: true,
  });
};

const addNotification = (state, action) => {
  const notifications = {...state.notifications};
  notifications[action.data.type + action.data.message] = action.data;
  return updateObject(state, {
    notifications,
  });
};

const removeNotification = (state, action) => {
  const notifications = {...state.notifications};
  delete notifications[action.id];
  return updateObject(state, {
    notifications,
  });
};

// Reducer function.
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_DATA:
      return setUserData(state, action);
    case actionTypes.ADD_NOTIFICATION:
      return addNotification(state, action);
    case actionTypes.REMOVE_NOTIFICATION:
      return removeNotification(state, action);
    case actionTypes.SET_USER_SETTINGS:
      return updateObject(state, {
        userSettings: updateObject(state.userSettings, action.userSettings),
      });
    case actionTypes.SESSION_DATA_RESTORED:
      return updateObject(state, {sessionDataRestored: true});
    case actionTypes.SET_SUBSCRIPTION_SETTINGS:
      return updateObject(state, {subscriptionSettings: action.data});
    default:
      return state;
  }
};

export default reducer;
